// install (please try to align the version of installed @nivo packages)
// yarn add @nivo/funnel
import { ResponsiveFunnel } from '@nivo/funnel'
const MyResponsiveFunnel = ({ datafunnel }) => (
    <ResponsiveFunnel
    data={datafunnel}
    margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
    direction="horizontal"
    shapeBlending={1}
    spacing={5}
    valueFormat=">-.4s"
    colors={{ scheme: 'set3' }}
    fillOpacity={10}
    borderWidth={20}
    borderColor={{ theme: 'grid.line.stroke' }}
    labelColor={{
        from: 'color',
        modifiers: [
            [
                'darker',
                3
            ]
        ]
    }}
    beforeSeparatorLength={100}
    beforeSeparatorOffset={20}
    afterSeparatorLength={100}
    afterSeparatorOffset={20}
    currentPartSizeExtension={10}
    currentBorderWidth={40}
    motionConfig={{
        mass: 146,
        tension: 90,
        friction: 1,
        clamp: false,
        precision: 0.01,
        velocity: 0
    }}
    />
)
export default MyResponsiveFunnel ;